// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section {
    margin-top: 5px;
    /*border-top: var(--appbuilder-border-thickness) solid var(--appbuilder-border-color);*/
    /*border-top-left-radius: var(--border-radius-top-left);
    border-top-right-radius: var(--border-radius-top-right);
    border-bottom-left-radius: var(--border-radius-bottom-left);
    border-bottom-right-radius: var(--border-radius-bottom-right);
    padding: 5px;*/
}
.label-fill{
    flex:1 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/app/appbuilder/menutabs/generic/generic.menu.tab.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,uFAAuF;IACvF;;;;kBAIc;AAClB;AACA;IACI,aAAa;AACjB","sourcesContent":[".section {\n    margin-top: 5px;\n    /*border-top: var(--appbuilder-border-thickness) solid var(--appbuilder-border-color);*/\n    /*border-top-left-radius: var(--border-radius-top-left);\n    border-top-right-radius: var(--border-radius-top-right);\n    border-bottom-left-radius: var(--border-radius-bottom-left);\n    border-bottom-right-radius: var(--border-radius-bottom-right);\n    padding: 5px;*/\n}\n.label-fill{\n    flex:1 0 auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
